import React from 'react';
import Score from './Score.jsx';
import WrongCounter from './WrongCounter.jsx';

const QuestionContainer = ({ mapSrc, score, wrongCounter }) => {
  return (
    <div className='question-container'>
      <Score score={score} />
      <WrongCounter wrong={wrongCounter} />
      <img className='map-svg' src={mapSrc} alt='map' />
    </div>
  );
};

export default QuestionContainer;
